import type { Organization } from '@/lib/services/organizations/organizations.types'

/** Sales demo organizations can't reach physical card readers: the API's reader routes answer 403. */
export function canReachCardReaders(
  organization: Pick<Organization, 'sales_demo'> | null | undefined
): boolean {
  return !organization?.sales_demo
}

/** Reader payments also need the shop's Stripe account. */
export function readerPaymentsAvailable(
  organization: Pick<Organization, 'sales_demo'> | null | undefined,
  stripeAccount: string | null | undefined
): boolean {
  return canReachCardReaders(organization) && Boolean(stripeAccount)
}
